<div class="card">
  <h5 class="page-title">User Roles</h5>
  <p>
    Manage who can sign in to this admin portal. <strong>Admin</strong> has full access.
    <strong>Ops</strong> only sees Hubs tools and can launch Hub Editor for assigned hubs.
    <strong>TinyPromo Ops</strong> can inspect TinyPromo cases and commissions. It does not receive Royal Ops access.
    WhiteList admins are listed here too (they were previously hidden when this screen showed Ops only).
  </p>

  <div class="p-grid p-formgrid p-mb-3" style="align-items: end;">
    <div class="p-field p-col-12 p-md-5">
      <label for="portal-ops-email">Email</label>
      <input
        id="portal-ops-email"
        pInputText
        type="email"
        name="portalOpsEmail"
        [(ngModel)]="email"
        placeholder="user@example.com"
        class="w-full"
        (keyup.enter)="create()"
      />
    </div>
    <div class="p-field p-col-12 p-md-2">
      <label for="portal-ops-role">Role</label>
      <p-dropdown
        id="portal-ops-role"
        [options]="roleOptions"
        [(ngModel)]="role"
        optionLabel="label"
        optionValue="value"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="p-field p-col-12 p-md-2">
      <button
        pButton
        type="button"
        [label]="isSaving ? 'Saving…' : 'Add / Update'"
        icon="pi pi-plus"
        [disabled]="isSaving"
        (click)="create()"
      ></button>
    </div>
    <div class="p-field p-col-12 p-md-3">
      <label for="portal-ops-filter">Filter list</label>
      <input
        id="portal-ops-filter"
        pInputText
        type="search"
        name="portalOpsFilter"
        [(ngModel)]="filterText"
        placeholder="Search email or role"
        class="w-full"
      />
    </div>
  </div>

  <div
    *ngIf="status"
    class="portal-ops-status"
    [class.portal-ops-status--success]="status.severity === 'success'"
    [class.portal-ops-status--error]="status.severity === 'error'"
    [class.portal-ops-status--warn]="status.severity === 'warn'"
  >
    {{ status.text }}
  </div>

  <p-table [value]="filteredData" [loading]="isLoading" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header">
      <tr>
        <th>Email</th>
        <th>Role</th>
        <th>Status</th>
        <th>Assigned hubs</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [class.portal-ops-row--new]="lastAddedEmail && row.email === lastAddedEmail">
        <td>{{ row.email }}</td>
        <td>
          <span
            class="portal-ops-role"
            [class.portal-ops-role--admin]="row.role === 'ADMIN'"
            [class.portal-ops-role--ops]="row.role === 'OPS'"
          >
            {{ row.role || '—' }}
          </span>
        </td>
        <td>{{ row.active ? 'Active' : 'Inactive' }}</td>
        <td>{{ row.assignedHubCount != null ? row.assignedHubCount : 0 }}</td>
        <td>
          <button
            pButton
            class="p-button-text p-mr-2"
            [label]="row.active ? 'Deactivate' : 'Activate'"
            (click)="setActive(row, !row.active)"
          ></button>
          <button
            *ngIf="row.role !== 'ADMIN'"
            pButton
            class="p-button-text p-mr-2"
            label="Make Admin"
            (click)="setRole(row, 'ADMIN')"
          ></button>
          <button
            *ngIf="row.role === 'ADMIN' || row.role === 'TINYPROMO_OPS'"
            pButton
            class="p-button-text p-mr-2"
            label="Make Ops"
            (click)="setRole(row, 'OPS')"
          ></button>
          <button
            *ngIf="row.role !== 'TINYPROMO_OPS'"
            pButton
            class="p-button-text p-mr-2"
            label="Make TinyPromo Ops"
            (click)="setRole(row, 'TINYPROMO_OPS')"
          ></button>
          <button
            *ngIf="row.role !== 'ADMIN'"
            pButton
            class="p-button-text p-button-danger"
            label="Delete"
            (click)="confirmDelete(row)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">
          {{ filterText ? 'No portal users match this filter.' : 'No portal users yet. Add an email address above.' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '480px'}"></p-confirmDialog>
